<template>
  <Loading v-if="loading" />
  <div class="grade">
    <FormKit
      id="grade-form"
      v-model="formData"
      type="form"
      :actions="false"
      @submit="submitHandler"
    >
      <ShowSettings
        :value="formData.show"
        :selected-option="formData.position"
        @update:selected-position="updateSelectedPosition"
        @select-option="selectShowSettings"
      />
      <TitleOptions :title="$t('titleUpperCase')" />
      <div class="grade__translations">
        <FormKit type="group" name="title_text">
          <div
            v-for="(translation, index) in translations"
            :key="index"
            class="container"
          >
            <span>{{ translation.label }}</span>
            <Input
              type="text"
              :name="translation.value"
              :value="formData.title_text[translation.value]"
            />
          </div>
        </FormKit>
      </div>
    </FormKit>
    <Button variant="filled" :title="$t('save')" @click="submitForm" />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { mapActions, mapState } from 'vuex';

import Loading from '@/views/Loading.vue';

import { translations } from '../configs';
import { OptionsScreen } from '@/store/modules/pharmacy/types';

import { mapScreensToSelectedPositions } from '@/components/UI/ShowSettings/configs';

@Options({
  name: 'Grade',
  components: {
    Loading
  },
  data() {
    return {
      loading: false,
      formData: {
        title_text: {
          fi: '',
          sv: '',
          en: ''
        },
        show: false,
        position: 0
      },
      payload: {},
      positionNotSelected: false,
      translations
    };
  },
  computed: {
    ...mapState('pharmacy', ['pharmacy'])
  },
  created() {
    this.show();
  },
  methods: {
    ...mapActions('pharmacy', ['getPharmacy', 'updateFeedbackTemplate']),
    async show() {
      this.loading = true;

      const { id } = this.$route.params;
      await this.getPharmacy(id);

      this.formData = {
        ...this.pharmacy.feedbackTemplate.grade_screen
      };
      this.loading = false;
    },
    updateSelectedPosition(position: number) {
      this.formData.position = position;
    },
    selectShowSettings() {
      this.showSettings = !this.showSettings;
    },
    cleanForm() {
      this.$formkit.reset('grade-form');
    },
    submitForm() {
      this.$formkit.submit('grade-form');
    },
    async submitHandler(data: OptionsScreen) {
      if (this.positionNotSelected) {
        this.payload = {
          grade_screen: {
            ...data
          }
        };
      } else {
        if (this.pharmacy) {
          const screens = this.pharmacy.feedbackTemplate;
          const name = this.$route.name.toLowerCase();

          const selectedPositions = mapScreensToSelectedPositions(
            screens,
            name
          );

          this.payload = {
            grade_screen: {
              ...data,
              position: selectedPositions.value
            }
          };
        }
      }

      this.loading = true;

      const { id } = this.$route.params;
      await this.updateFeedbackTemplate({ data: this.payload, pharmacyId: id });
      this.loading = false;
    }
  },
  watch: {
    pharmacy() {
      if (this.pharmacy) {
        this.formData = {
          ...this.pharmacy.feedbackTemplate.grade_screen
        };
      }
    }
  }
})
export default class Grade extends Vue {}
</script>

<style lang="scss" scoped>
.grade {
  padding: 24px;
  #grade-form {
    margin-bottom: 32px;
    .grade__translations {
      width: 450px;
      .container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 30px;
        &:last-child {
          margin-bottom: 0;
        }
        .input {
          display: inline-block;
          width: 350px;
          margin-left: 15px;
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
